package uz.ferro.shop.model

import kotlinx.serialization.Serializable

@Serializable
data class LayoutRow(
    val items: List<LayoutItem>
)
